// Rótulos da aba "Cartão internacional" (CHECKOUT-02 / WEB-150). Estados e origens vêm do
// contrato; aqui só o texto pt-BR e o que a linha pode fazer.

import type {
  CheckoutSessionOrigin,
  CheckoutSessionStatus,
} from '../../api/queries/checkout-sessions.ts';

export const SESSION_STATUS_LABEL: Record<CheckoutSessionStatus, string> = {
  open: 'Aberto',
  completed: 'Pago',
  expired: 'Expirado',
};

export const SESSION_STATUS_VARIANT: Record<
  CheckoutSessionStatus,
  'warning' | 'paid' | 'secondary'
> = {
  open: 'warning',
  completed: 'paid',
  expired: 'secondary',
};

export const SESSION_ORIGIN_LABEL: Record<CheckoutSessionOrigin, string> = {
  panel: 'Painel',
  api: 'API',
  leztybot: 'LeztyBot',
};

/** Filtros da aba: `undefined` = Todos. */
export const SESSION_STATUS_FILTERS = [
  'open',
  'completed',
  'expired',
] as const satisfies readonly CheckoutSessionStatus[];

export const SESSION_FILTER_LABEL: Record<(typeof SESSION_STATUS_FILTERS)[number], string> = {
  open: 'Abertos',
  completed: 'Pagos',
  expired: 'Expirados',
};

/** Só link em aberto serve pra mandar ao comprador. */
export function canCopySession(session: { status: CheckoutSessionStatus }): boolean {
  return session.status === 'open';
}
